import React, { useState } from "react";
import { useTranslation } from "react-i18next"; 
import Header from "../../components/Header/Header";
import "./FAQ.css";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);



  const { t } = useTranslation();

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };


  const faqCategories = t("faq.categories", { returnObjects: true });

  return (
    <div className="main-container">
      <Header />
      <div className="faq-container">
        <div className="faq-header">
          {/* Title y subtitle */}
          <h1>{t("faq.header.title")}</h1>
          <p>{t("faq.header.subtitle")}</p>
        </div>

        <div className="faq-content">
        
          {Object.entries(faqCategories).map(([categoryKey, categoryValue], categoryIndex) => {
            const { title, questions } = categoryValue;
            return (
              <div key={categoryKey} className="faq-category">
                <h2 className="category-title">{title}</h2>
                {questions.map((item, questionIndex) => {
        
                  const globalIndex = `${categoryIndex}-${questionIndex}`;
                  return (
                    <div
                      key={globalIndex}
                      className={`faq-item ${activeIndex === globalIndex ? "active" : ""}`}
                    >
                      <div
                        className="faq-question"
                        onClick={() => toggleAccordion(globalIndex)}
                      >
                        <h3>{item.q}</h3>
                        <span className="faq-icon">
                          {activeIndex === globalIndex ? "−" : "+"}
                        </span>
                      </div>
                      <div
                        className={`faq-answer ${
                          activeIndex === globalIndex ? "active" : ""
                        }`}
                      >
                        <p>{item.a}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
